import * as React from 'react';
import { PortalCheckboxField, PortalDatePicker } from 'components/FormControls';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import * as c from 'models/constants';
import { Dispatch } from 'redux';
import { IStore } from 'redux/IStore';
import { setDateFilter } from 'redux/modules/shop/offices';
import moment = require('moment');

type ReduxInjectedProps = Partial<ReturnType<typeof stateToProps> & ReturnType<typeof dispatchToProps>>;

interface IProps extends ReduxInjectedProps {
	t?: (key: string) => string;
	onChange?: (value: Date) => void;
	displayOnlyDatepicker?: boolean;
	filterDate?: string;
	resetAppliedFilters?: boolean;
	setResetAppliedFilters?: React.Dispatch<React.SetStateAction<boolean>>;
}

interface IState {
	currentDateFilter: Date;
}

const stateToProps = (state: IStore) => ({
	dateFilter: state.offices?.dateFilter,
});

const dispatchToProps = (dispatch: Dispatch<IStore>) => ({
	setDateFilter: (dateFilter: number) => dispatch(setDateFilter(dateFilter)),
	dispatch,
});

@connect(stateToProps, dispatchToProps)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class DateFilter extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			currentDateFilter: undefined,
		};

		this.handleDateFilterChange = this.handleDateFilterChange.bind(this);
	}

	private handleDateFilterChange(date: Date) {
		if (date) {
			const weekDay = moment(date).locale('en-us').day(); // must start with Sunday = 0 (hardcoded on API)
			if (this.props.onChange) {
				this.props.onChange(date as any);
			}

			if (weekDay || weekDay === 0) {
				this.props.setDateFilter(weekDay);
			}

			this.setState({
				currentDateFilter: date,
			});
			this.props.setResetAppliedFilters ? this.props.setResetAppliedFilters(false) : '';
		} else {
			if (this.props.onChange) {
				this.props.onChange(null as any);
			}

			this.setState({
				currentDateFilter: null,
			});

			this.props.setResetAppliedFilters ? this.props.setResetAppliedFilters(false) : '';
			this.props.setDateFilter(null);
		}
	}

	render() {
		const { t, dateFilter, displayOnlyDatepicker, filterDate, resetAppliedFilters } = this.props;
		const { currentDateFilter } = this.state;

		////////////////////////////////////////////////////////////////////////
		// Custom datepicker
		////////////////////////////////////////////////////////////////////////
		const handleTodayCheckboxClick = () => {
			this.handleDateFilterChange(new Date());
		};

		const handleTomorrowCheckboxClick = () => {
			this.handleDateFilterChange(moment(new Date()).add(1, 'd').toDate());
		};

		const customCalendarSideColumn: JSX.Element = (
			<>
				<PortalCheckboxField
					input={{
						name: 'today',
						checked:
							!resetAppliedFilters &&
							(currentDateFilter
								? moment(currentDateFilter).isSame(moment(), 'day')
								: filterDate
								  ? moment(filterDate).isSame(moment(), 'day')
								  : false),
					}}
					meta={{}}
					type="checkbox"
					onChangeAction={handleTodayCheckboxClick}
					label={t('JobDeadlineRefinement_1')}
					isDisabled={false}
				/>
				<PortalCheckboxField
					input={{
						name: 'tomorrow',
						checked:
							!resetAppliedFilters &&
							(currentDateFilter
								? moment(currentDateFilter).isSame(moment().add(1, 'day'), 'day')
								: filterDate
								  ? moment(filterDate).isSame(moment().add(1, 'day'), 'day')
								  : false),
					}}
					meta={{}}
					type="checkbox"
					onChangeAction={handleTomorrowCheckboxClick}
					label={t('JobDeadlineRefinement_2')}
					isDisabled={false}
				/>
			</>
		);
		////////////////////////////////////////////////////////////////////////
		return (
			<>
				<PortalDatePicker
					input={{
						value:
							!resetAppliedFilters &&
							((dateFilter || dateFilter === 0) && currentDateFilter
								? moment(currentDateFilter).toISOString()
								: filterDate
								  ? new Date(filterDate)
								  : undefined),
						minDate: new Date(),
						onChange: this.handleDateFilterChange,
					}}
					placeholderText={t('BookAppointment_Schedule_Filter_Date')}
					onChange={this.handleDateFilterChange}
					className={`${c.SHOPS_DATE_FILTER} ${displayOnlyDatepicker ? ' onlyDatepicker' : ''}`}
					iconName="datefilter"
					customIconSizeWidth={16}
					customIconSizeHeight={16}
					highlightWhenValueSet={true}
					inline={displayOnlyDatepicker}
					customCalendarContainerEl={customCalendarSideColumn}
					key={dateFilter}
				/>
			</>
		);
	}
}

export default DateFilter;
